import BillingsOrderCargoTaxiDraftResponse, {
  BillingsOrderCargoTaxiDraftResponseData,
  BillingsOrderCargoTaxiDraftResponseDataBillingContribution,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionBaseAmount,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHaltings,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHighways,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountBeingLate,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOptimization,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOther,
  BillingsOrderCargoTaxiDraftResponseDataBillingContributionType,
  BillingsOrderCargoTaxiDraftResponseDataBillingNode,
  BillingsOrderCargoTaxiDraftResponseDataCargoOrder,
  BillingsOrderCargoTaxiDraftResponseDataContract,
  BillingsOrderCargoTaxiDraftResponseDataContractBillingModel,
  BillingsOrderCargoTaxiDraftResponseDataContractCargoCompany,
  BillingsOrderCargoTaxiDraftResponseDataStatus,
} from "../../../../../api/raily/billings/order/cargo-taxi/draft/billings-order-cargo-taxi-draft.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsOrderCargoTaxiDraft, {
  BillingsOrderCargoTaxiDraftBillingContribution,
  BillingsOrderCargoTaxiDraftBillingContributionType,
  BillingsOrderCargoTaxiDraftBillingNode,
  BillingsOrderCargoTaxiDraftCargoOrder,
  BillingsOrderCargoTaxiDraftContract,
  BillingsOrderCargoTaxiDraftContractCargoCompany,
} from "./billings-order-cargo-taxi-draft";

const createBillingContributionBaseAmount = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionBaseAmount,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.BASE_AMOUNT,
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
  };
};

const createBillingContributionChargeHaltings = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHaltings,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.CHARGE_HALTING,
    comment: contribution.comment,
    distance: contribution.distance,
    amount: contribution.amount,
  };
};

const createBillingContributionChargeHighways = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHighways,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.CHARGE_HIGHWAYS,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionContractCorrectionPercentage = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionContractCorrectionPercentage,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE,
    comment: contribution.comment,
    percentage: contribution.percentage,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountBeingLate = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountBeingLate,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_BEING_LATE,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountIncompatibleCar = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountIncompatibleCar,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountOptimization = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOptimization,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_OPTIMIZATION,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountOther = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOther,
): BillingsOrderCargoTaxiDraftBillingContribution => {
  return {
    type: BillingsOrderCargoTaxiDraftBillingContributionType.DISCOUNT_OTHER,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContribution = (
  contribution: BillingsOrderCargoTaxiDraftResponseDataBillingContribution,
): BillingsOrderCargoTaxiDraftBillingContribution | undefined => {
  switch (contribution.type) {
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.BASE_AMOUNT:
      return createBillingContributionBaseAmount(contribution);
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.CHARGE_HALTING:
      return createBillingContributionChargeHaltings(contribution);
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.CHARGE_HIGHWAYS:
      return createBillingContributionChargeHighways(contribution);
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE:
      return createBillingContributionContractCorrectionPercentage(
        contribution,
      );
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_BEING_LATE:
      return createBillingContributionDiscountBeingLate(contribution);
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR:
      return createBillingContributionDiscountIncompatibleCar(contribution);
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_OPTIMIZATION:
      return createBillingContributionDiscountOptimization(contribution);
    case BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_OTHER:
      return createBillingContributionDiscountOther(contribution);
    default:
      return undefined;
  }
};

const createBillingContributions = (
  contributions: BillingsOrderCargoTaxiDraftResponseDataBillingContribution[],
): BillingsOrderCargoTaxiDraftBillingContribution[] => {
  return contributions
    .map(createBillingContribution)
    .filter(
      (contribution) => contribution,
    ) as BillingsOrderCargoTaxiDraftBillingContribution[];
};

const createBillingNode = (
  node: BillingsOrderCargoTaxiDraftResponseDataBillingNode,
): BillingsOrderCargoTaxiDraftBillingNode => {
  return {
    allowCharge: node.allowCharge,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    lat: node.lat,
    lon: node.lon,
    nodeUuid: node.nodeId,
    plannedDistance: node.plannedDistance,
    uuid: node.id,
    checkoutDate: node.checkoutDate,
    checkoutEventUuid: node.checkoutEventId,
    orderUuid: node.orderId,
    plannedDate: node.plannedDate,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderCargoTaxiDraftResponseDataBillingNode[],
): BillingsOrderCargoTaxiDraftBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createCargoOrder = (
  cargoOrder: BillingsOrderCargoTaxiDraftResponseDataCargoOrder,
): BillingsOrderCargoTaxiDraftCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    uuid: cargoOrder.id,
  };
};

const createCargoCompany = (
  cargoCompany: BillingsOrderCargoTaxiDraftResponseDataContractCargoCompany,
): BillingsOrderCargoTaxiDraftContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
    displayName: cargoCompany.displayName,
  };
};

const createModel = (
  model: BillingsOrderCargoTaxiDraftResponseDataContractBillingModel,
): BillingModel => {
  switch (model) {
    case BillingsOrderCargoTaxiDraftResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderCargoTaxiDraftResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderCargoTaxiDraftResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderCargoTaxiDraftResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createContract = (
  contract: BillingsOrderCargoTaxiDraftResponseDataContract,
): BillingsOrderCargoTaxiDraftContract => {
  return {
    allowChargeDuringRide: contract.allowChargeDuringRide,
    allowChargeWhileApproaching: contract.allowChargeWhileApproaching,
    allowChargeWhileReturning: contract.allowChargeWhileReturning,
    cargoCompany: createCargoCompany(contract.cargoCompany),
    discountLimit: contract.discountLimit,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: createModel(contract.model),
  };
};

const createStatus = (
  status: BillingsOrderCargoTaxiDraftResponseDataStatus,
): BillingStatus => {
  switch (status) {
    case BillingsOrderCargoTaxiDraftResponseDataStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsOrderCargoTaxiDraftResponseDataStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsOrderCargoTaxiDraftResponseDataStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsOrderCargoTaxiDraftResponseDataStatus.REOPENED:
      return BillingStatus.REOPENED;
    case BillingsOrderCargoTaxiDraftResponseDataStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
  }
};

const createData = (
  data: BillingsOrderCargoTaxiDraftResponseData,
): BillingsOrderCargoTaxiDraft => {
  return {
    allContributionsAmount: data.allContributionsAmount,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    amountForDistance: data.amountForDistance,
    baseAmountValue: data.baseAmountValue,
    billingContributions: createBillingContributions(data.billingContributions),
    billingNodes: createBillingNodes(data.billingNodes),
    cargoOrder: createCargoOrder(data.cargoOrder),
    contract: createContract(data.contract),
    contractCorrectionPercentage: data.contractCorrectionPercentage,
    date: data.date,
    distance: data.distance,
    passengers: data.passengers,
    planEntryUuid: data.planEntryId,
    status: createStatus(data.status),
    sumOfDiscounts: data.sumOfDiscounts,
  };
};

const create = (
  response: BillingsOrderCargoTaxiDraftResponse,
): BillingsOrderCargoTaxiDraft => {
  return createData(response.data);
};

const billingsOrderCargoTaxiDraftFactory = {
  create,
};

export default billingsOrderCargoTaxiDraftFactory;
